import Survey from '@/models/Survey';


const GET_SURVEY = 'get_survey';
const GET_SURVEY_REQUEST = 'get_survey_request';
const GET_SURVEY_SUCCESS = 'get_survey_success';
const GET_SURVEY_ERROR = 'get_survey_error';

export { GET_SURVEY };

export default {
    state: {
        survey: {},
        loading: false,
        surveyErrors: [],
    },
    mutations: {
        [GET_SURVEY_REQUEST]: (state) => {
            state.survey = {
                rows: [],
            };
            state.loading = true;
            state.surveyErrors = [];
        },
        [GET_SURVEY_SUCCESS]: (state, { survey, rows }) => {
            state.survey = survey;
            state.survey.rows = rows;
            state.loading = false;
            state.surveyErrors = [];
        },
        [GET_SURVEY_ERROR]: (state, { errors }) => {
            state.survey = {
                rows: [],
            };
            state.loading = false;
            state.surveyErrors = errors;
        }
    },
    actions: {
        [GET_SURVEY]: ({ commit, state, rootState}, { trajectoryId = rootState.trajectory.trajectory.id, surveyId = state.survey.id }) => {
            commit(GET_SURVEY_REQUEST);
            return new Promise((resolve, reject) => {
                const TrajectorySurvey = Survey.makeModel(`/trajectories/${trajectoryId}/surveys`);
                TrajectorySurvey.document(surveyId)
                    .then(survey => {
                        commit(GET_SURVEY_SUCCESS, { survey });
                        resolve(survey);
                    })
                    .catch(err => {
                        commit(GET_SURVEY_ERROR, { err });
                        reject(err);
                    });
            });
        }
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/survey.js